import script from "./SectionVendorCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionVendorCard.vue?vue&type=script&setup=true&lang=ts"

import "./SectionVendorCard.vue?vue&type=style&index=0&id=67ef6aa6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67ef6aa6"]])

export default __exports__